import { SITE_URL } from '@/lib/seo';
import { useLanguage } from '@/contexts/LanguageContextNew';
import { useSchemaDOM } from '@/hooks/useSchemaDOM';

interface ServiceCompetitorSchemaProps {
  serviceName: string;
  category: 'bpo' | 'digital' | 'consulting';
}

export function ServiceCompetitorSchema({ serviceName, category }: ServiceCompetitorSchemaProps) {
  const { language } = useLanguage();
  const entitySchema = {
    '@context': 'https://schema.org', '@type': 'Organization', '@id': `${SITE_URL}/#organization`,
    name: 'Call IT Dev', url: SITE_URL,
    sameAs: ['https://www.linkedin.com/company/callitdev', 'https://twitter.com/callitdev'],
    naics: category === 'bpo' ? '561422' : '541511',
    foundingDate: '2018',
    knowsAbout: [serviceName, 'Business Process Outsourcing', 'Software Development'],
  };
  useSchemaDOM([entitySchema], `service-competitor-${serviceName.toLowerCase().replace(/\s+/g, '-')}`, [language, serviceName]);
  return null;
}
